module.exports = __webpack_public_path__ + "img/T938.cd935a3b.jpg";